import React from 'react'
import { EMBED_PARTNERS, EMBED_PRODUCTS } from 'parameters/index'
import ExplorePageLayout from './layouts/ExplorePageLayout'
import { InjectedContentfulProps, withContentful } from 'components/vendor/Contentful/withContentful'
import styled from '@emotion/styled'
import { CampaignIDs } from 'types/index'
import { ExplorePageReduxProps } from 'types/page'
import { useHasMounted } from 'lib/renderWrappers/ClientOnly'
import { Nullable } from 'lib'
import MultiProductWidget from 'components/vendor/MultiProductWidget/MultiProductWidget'

interface ContentProps {
	campaign: CampaignIDs
	mode?: 'refinance' | 'normal'
}

type Props = ExplorePageReduxProps & ContentProps

const MortgagePageContent = ({ mode }: ContentProps): Nullable<JSX.Element> => {
	const hasMounted = useHasMounted()
	const isRefinance: boolean = mode === 'refinance'
	const product: string = isRefinance ? EMBED_PRODUCTS.MORTGAGE_REFINANCE : EMBED_PRODUCTS.MORTGAGE
	if (!hasMounted) return null

	return <MultiProductWidget product={product} partner={EMBED_PARTNERS.FIONA} isCnfEmbedExperience={true} />
}

const MortgagePage = ({ articles, campaign, mode = 'normal' }: Props & InjectedContentfulProps): JSX.Element => {
	return (
		<>
			<ExplorePageLayout articles={articles} hideAdvertiserDisclosure={true}>
				<MinHeight>
					<MortgagePageContent campaign={campaign} mode={mode} />
				</MinHeight>
			</ExplorePageLayout>
		</>
	)
}

export default withContentful(MortgagePage)

const MinHeight = styled.div`
	min-height: 600px;
`
